import TopicsSemantic from "./TopicsSemantic"; // Основной компонент

export default TopicsSemantic; // Экспорт по умолчанию
